import { Specification } from 'gql/autogen/Specification';
import { EnrichedOfferOption } from 'gql/autogen/EnrichedOfferOption';
import { Offer } from 'gql/autogen/Offer';
import { Detail } from 'gql/autogen/Detail';

export const getTimeslotFromSpecification = (specifications: Specification[] | undefined): string => {
    if (!specifications) return '';
    const TIME = 'time';
    return specifications.find((spec) => spec.key === TIME)?.specification || '';
};

export const getEnrichedOfferOptionById = (enrichedOfferOptions: EnrichedOfferOption[] | undefined, offerOptionId: number): EnrichedOfferOption | undefined => {
    if (!enrichedOfferOptions) return undefined;
    return enrichedOfferOptions.find((option) => option.offerOptionId === offerOptionId);
};

export const getSelectedOfferFromOfferGrouping = (possibleOfferOptions: EnrichedOfferOption[]): EnrichedOfferOption | undefined => {
    return possibleOfferOptions.length === 1 && possibleOfferOptions[0].isAvailable ? possibleOfferOptions[0] : undefined;
};

export const getFirstAvailableEnrichedOfferOption = (enrichedOfferOptions: EnrichedOfferOption[]): EnrichedOfferOption | undefined => {
    return enrichedOfferOptions.find((option) => option.isAvailable);
};

export const getOfferOptionToken = (enrichedOfferOptions: EnrichedOfferOption[]): EnrichedOfferOption | undefined => {
    return enrichedOfferOptions.find((x) => x.offerOptionToken);
};

export const getValidOffers = (offers: Offer[]): { validAvailableOffers: Offer[]; validUnavailableOffers: Offer[] } => {
    const validAvailableOffers = offers.filter((offer) => offer && offer.isAvailable && offer.enrichedOfferOption && offer.enrichedOfferOption.length > 0);
    const validUnavailableOffers = offers.filter((offer) => offer && !offer.isAvailable && offer.enrichedOfferOption && offer.enrichedOfferOption.length > 0);
    return { validAvailableOffers, validUnavailableOffers };
};

export const getDetail = (detail: Detail, offerDetailRef?: string) => {
    return detail.offerDetails?.find((d) => d.offerDetailRef === offerDetailRef);
};

export const getIsQueryParamEnrichedOfferExist = (offers: Offer[], enrichedOfferId: number): boolean => {
    const enrichedOfferOptions = offers.reduce<EnrichedOfferOption[]>((acc, offer) => {
        return acc.concat(offer.enrichedOfferOption || []);
    }, []);

    return enrichedOfferOptions.some((enrichedOfferOption) => enrichedOfferOption.offerId === enrichedOfferId);
};
